import {UserModel} from "../../models/user";
import React from "react";
import {useTranslation} from "next-i18next";
import Table from 'rc-table';
import {Heading4, Paragraph, TextStyles} from "../text";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {
  selectIsLoadingAffiliates,
  selectIsUpdating,
  updateAffiliateStatus
} from "../../redux/affiliate/affiliateAdminSlice";
import {ColumnProps} from "rc-table/lib/sugar/Column";
import {UserAffiliateStatus} from "../../models/userAffiliateProgram";
import {Button} from "../buttons/Button";
import {ArrowDownIcon} from "../icons";

export interface AffiliateAdminTableProps {
  affiliates: UserModel[]
  onLoadMoreClicked: () => void
}

const TableHeader: React.FC<{ isFirst?: boolean, isLast?: boolean }> = ({ isFirst, children, isLast }) => {
  return <div className={`py-3 px-4 whitespace-nowrap flex items-center bg-fg-gray-surface-light h-12 ${isFirst ? 'rounded-tl-lg' : isLast ? 'rounded-tr-lg' : ''}`}>
    {children}
  </div>
}

const TableCell: React.FC<any> = ({ children }) => {
  return <div className={`py-3 px-4 whitespace-nowrap border-t border-fg-gray-surface h-16 flex items-center`}>
    {children}
  </div>
}

const AffiliateAdminTableStatusButton: React.FC<{ user: UserModel }> = ({ user }) => {
  const isUpdating = useAppSelector(state => selectIsUpdating(state, user.userId))
  const dispatch = useAppDispatch()

  return <div className="relative">
    <div className="absolute top-0 left-0">
      <Button
        isLoading={isUpdating}
        buttonStyle="secondary"
        trailingIconSizeClass="h-3 w-3"
        trailingicon={<ArrowDownIcon />}>
        <span className="capitalize">{user.affiliateProgram?.affiliateStatus}</span>
      </Button>
    </div>

    <select
      id="status"
      name="status"
      onClick={e => {
        e.stopPropagation()
      }}
      defaultValue={user.affiliateProgram?.affiliateStatus}
      onChange={e => {
        if (!e.target.value) return

        const userId = user.userId
        if (!userId) return
        dispatch(updateAffiliateStatus({ affiliate_user_id: userId, status: e.target.value as UserAffiliateStatus }))
      }}
      className={`appearance-none opacity-0 transition-colors bg-fg-primary hover:bg-fg-gray-surface-dark border-0 cursor-pointer text-center focus:ring-0 rounded-full px-5 py-2 flex flex-row items-center ${TextStyles.Body}`}
    >
      <option key={'active'} value={'active'}>Active</option>
      <option key={'inactive'} value={'inactive'}>Inactive</option>
    </select>
  </div>
}

export const AffiliateAdminTable: React.FC<AffiliateAdminTableProps> = ({ affiliates, onLoadMoreClicked }) => {
  const isLoadingAffiliates = useAppSelector(selectIsLoadingAffiliates)

  const columns: ColumnProps<UserModel>[] = [
    {
      title: <TableHeader isFirst={true}>
        <Heading4 className="text-fg-gray-dark">Name</Heading4>
      </TableHeader>,
      dataIndex: 'name',
      onHeaderCell: () => {
        return {
          onClick: () => {

          }
        }
      },
      render: (text, record) => (
        <TableCell>
          <Paragraph>{`${record.firstName ?? ''} ${record.lastName ?? ''}`}</Paragraph>
        </TableCell>
      )
    },
    {
      title: <TableHeader>
        <Heading4 className="text-fg-gray-dark">Email</Heading4>
      </TableHeader>,
      dataIndex: 'email',
      onHeaderCell: () => {
        return {
          onClick: () => {

          }
        }
      },
      render: (text, record) => (
        <TableCell>
          <Paragraph>{record.email}</Paragraph>
        </TableCell>
      )
    },
    {
      title: <TableHeader isLast={true}>
        <Heading4 className="text-fg-gray-dark">Status</Heading4>
      </TableHeader>,
      dataIndex: 'status',
      onHeaderCell: () => {
        return {
          onClick: () => {

          }
        }
      },
      render: (text, record) => {
        return <TableCell>
          <AffiliateAdminTableStatusButton user={record} />
        </TableCell>
      }
    },
  ]

  return <Table
    className="rounded-lg border border-fg-gray-surface fg-table"
    scroll={{x: true}}
    data={affiliates}
    columns={columns}
    emptyText={() => {
      return <div className="w-full h-16 flex items-center justify-center">
        <Paragraph>No Affiliates</Paragraph>
      </div>
    }}
    footer={() => {
      return <div className="w-full flex items-center justify-center py-8 border-t border-fg-gray-surface">
        <Button
          buttonStyle="secondary"
          isLoading={isLoadingAffiliates}
          onClick={() => {
            onLoadMoreClicked()
          }}
        >
          Load More
        </Button>
      </div>
    }}
  >

  </Table>
}